import { FigureData } from "components/organisms/manuscript/editor/visual/figure/figure-modal";

export function getEnvironmentName(node, state) {
    if (node?.type?.is?.("$Environment")) {
        node = node.getChild("BeginEnv");
    }

    if (!node?.type?.is?.("BeginEnv") && !node?.type?.is?.("EndEnv")) {
        return null;
    }

    const nameNode = node.getChild("EnvNameGroup")?.getChild("OpenBrace")?.nextSibling;
    if (!nameNode || nameNode.type.is("CloseBrace")) {
        return null;
    }

    return state.sliceDoc(nameNode.from, nameNode.to);
}

export const getUnstarredEnvironmentName = (node, state) => getEnvironmentName(node, state)?.replace(/\*$/, "");

export function getEnvironmentArguments(environmentNode) {
    return environmentNode.getChild("BeginEnv")?.getChildren("TextArgument") || [];
}

function getOptionalArgumentContent(optionalArgs) {
    if (!optionalArgs) {
        return null;
    }

    const shortOptionalArg = optionalArgs.getChild("ShortOptionalArg");
    if (shortOptionalArg) {
        return shortOptionalArg;
    }

    const openBracket = optionalArgs.getChild("OpenBracket");
    const closeBracket = optionalArgs.getChild("CloseBracket");
    if (!openBracket || !closeBracket) {
        return null;
    }

    return {
        from: openBracket.to,
        to: closeBracket.from,
    };
}

function getGraphicsOptionalArgument(node, argumentNode) {
    return argumentNode?.getChild("OptionalArgument") || node.node.getChild("OptionalArgument");
}

function parseGraphicsWidth(optionalArgContent) {
    return optionalArgContent.match(
        /^\s*width\s*=\s*([0-9]|(?:[0-9]*\.[0-9]+)|(?:[0-9]+\.))\\(linewidth|pagewidth|textwidth|hsize|columnwidth)\s*$/,
    );
}

export function parseFigureData(figureEnvironmentNode, state) {
    let caption = null;
    let label = null;
    let file;
    let width;
    let graphicsCommand = null;
    let graphicsCommandArguments = null;
    let unknownGraphicsArguments;
    let error = false;

    figureEnvironmentNode.cursor().iterate((node) => {
        if (error) {
            return false;
        }
        if (node.type.is("Caption")) {
            if (caption) {
                error = true;
                return false;
            }
            caption = { from: node.from, to: node.to };
        }
        if (node.type.is("Label")) {
            if (label) {
                error = true;
                return false;
            }
            label = { from: node.from, to: node.to };
        }
        if (node.type.is("IncludeGraphics") || node.type.is("IncludeSvg")) {
            if (file) {
                error = true;
                return false;
            }
            graphicsCommand = { from: node.from, to: node.to };
            const argumentNodeName = node.type.is("IncludeSvg") ? "IncludeSvgArgument" : "IncludeGraphicsArgument";
            const argumentNode = node.node.getChild(argumentNodeName);
            const content = argumentNode?.getChild("FilePathArgument")?.getChild("LiteralArgContent");
            if (!content) {
                error = true;
                return false;
            }
            file = {
                from: content.from,
                to: content.to,
                path: state.sliceDoc(content.from, content.to) + (node.type.is("IncludeSvg") ? ".svg" : ""),
            };

            const optionalArgs = getGraphicsOptionalArgument(node, argumentNode);
            const optionalArgContent = getOptionalArgumentContent(optionalArgs);
            if (optionalArgContent) {
                graphicsCommandArguments = {
                    from: optionalArgContent.from,
                    to: optionalArgContent.to,
                };
                unknownGraphicsArguments = state.sliceDoc(graphicsCommandArguments.from, graphicsCommandArguments.to);
            }
            const widthMatch = unknownGraphicsArguments ? parseGraphicsWidth(unknownGraphicsArguments) : null;
            if (widthMatch) {
                width = Number(widthMatch[1]);
                if (widthMatch[2] === "linewidth") {
                    unknownGraphicsArguments = "";
                }
            }
        }
        return undefined;
    });

    if (error || !file) {
        return null;
    }

    return new FigureData({
        from: figureEnvironmentNode.from,
        to: figureEnvironmentNode.to,
        caption,
        label,
        file,
        width,
        unknownGraphicsArguments,
        graphicsCommandArguments,
        graphicsCommand,
    });
}
